var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_c('el-scrollbar',{staticClass:"main-wrapper"},[(Object.keys(_vm.answerData).length > 0)?_c('StudentAnswerDetail',{attrs:{"answerData":_vm.answerData}}):_c('div',{staticStyle:{"text-align":"center","margin-top":"40px"}},[_vm._v("暂无数据")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }